import { mapGetters } from 'vuex';
import { toNumeral, numerals } from 'util/dom/mq';


export default {
    computed: {
        ...mapGetters(['viewport']),
        isMobile() {
            return (toNumeral(this.viewport.mq.query) <= numerals.LG);
        },
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/is-mobile/index.js